<div class="form-floating">
  <input theme="ct-datepicker" [formControl]="date" [dpDayPicker]="datePickerConfig()" class="form-control"
    (keydown)="$event.preventDefault();" (onChange)="onChange();" [placeholder]="placeholder() | transloco" readonly
    id="date">
  @if (control().value) {
  <fa-icon [icon]="fontawesomeService.regular.times"
    (click)="date.patchValue(null); control().reset()"></fa-icon>
  }
  <label for="date">{{placeholder() | transloco}}</label>
</div>